import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneMatchListPayload } from '@app-store/slices/matchLists/oneMatchList'

interface TaskAction extends Action {
    payload: IOneMatchListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchLists.oneMatchList

function* getOneMatchListTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/match-lists/one/${payload.matchListId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getOneMatchList(): any {
    yield takeLatest<TaskAction>(onRequest, getOneMatchListTask)
}

export default getOneMatchList
